import React from "react";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { compose } from 'react-apollo';
import { connect } from "react-redux";
import { Form, reduxForm } from "redux-form";
import { injectIntl } from "react-intl";

import CommonFields from "../../CommonFields/CommonFields";
import Link from "../../Link/Link";

import messages from "../../../locale/messages";
import submit from './submit';
import validate from "./validate";

import s from './EditProfileInfo.css';
import bt from '../../../components/commonStyle.css';
import { dob } from "../../../helpers/dobHelpers";

class EditProfileInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countryCode: 'US',
            country: '+1'
        }
    }

    componentWillMount() {
        const { change, initialValues } = this.props;
        const { countryCode, country } = this.state;
        let day, month, year, email;

        if (initialValues && initialValues?.dateOfBirth) {
            const dateOfBirth = initialValues?.dateOfBirth;
            let dateOfBirthArray = dateOfBirth.split("-");
            month = Number(dateOfBirthArray[0] - 1)
            year = dateOfBirthArray[1]
            day = dateOfBirthArray[2];
        }

        let days = dob(day);
        let months = dob(month);

        change('day', days);
        change('month', months);
        change('year', year);
        change('countryCode', countryCode);
        change('dialCode', country);
        change('email', initialValues?.profileBanStatus?.email)
    }

    render() {
        const { handleSubmit, initialValues, userId, isAdmin } = this.props;
        const { formatMessage } = this.props.intl;
        const title = <span>{formatMessage(messages.editUserInfo)}</span>;
        return (
            <div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
                <h3 className={cx(bt.listingTitleText, bt.space5)}>{title}</h3>
                {
                    isAdmin && <div className={s.gobackButton}>
                        <Link to={"/siteadmin/users"} className={cx(bt.btnPrimaryBorder,'bgBlack')}> {formatMessage(messages.goBack)} </Link>
                    </div>
                }
                <Form onSubmit={handleSubmit(submit)}>
                    <CommonFields initialValues={initialValues} userId={userId} />
                </Form>
            </div>
        )
    }
}

EditProfileInfo = reduxForm({
    form: 'EditProfileInfo',
    validate
})(EditProfileInfo);

const mapState = (state) => ({
    isAdmin: state?.runtime?.isAdminAuthenticated
})

const mapDispatch = {}

export default compose(injectIntl, withStyles(s), connect(mapState, mapDispatch))(EditProfileInfo);